import React from 'react';
import { Form, Input, DatePicker } from 'antd';
import locale from 'antd/lib/date-picker/locale/ru_RU';
const { Group } = Input;

const DateCreated = ({ form }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const createdFromValue = getFieldValue('created_from');
  const createdToValue = getFieldValue('created_to');

  return (
    <Form.Item label="Дата добавления:" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('created_from')(
          <DatePicker
            locale={locale}
            disabledDate={startValue =>
              createdToValue && startValue.valueOf() > createdToValue.valueOf()
            }
            style={{ width: '50%' }}
            placeholder="от"
            format={'DD.MM.YYYY'}
          />
        )}
        {getFieldDecorator('created_to')(
          <DatePicker
            locale={locale}
            style={{ width: '50%' }}
            disabledDate={endValue =>
              createdFromValue &&
              endValue.valueOf() <= createdFromValue.valueOf()
            }
            placeholder="до"
            format={'DD.MM.YYYY'}
          />
        )}
      </Group>
    </Form.Item>
  );
};
export default DateCreated;
